export enum ButtonBookmarkType {
  FEED = 'feed',
  LIST_MAP = 'listMap',
  DEFAULT_LIST_MAP = 'defaultListMap',
  MY_LIST_MAP = 'myListMap',
  MY_THEME = 'myTheme',
  OTHER_LIST_MAP = 'otherListMap',
  REVIEW_END = 'reviewEnd',
  THEMELIST = 'themelist',
  VISIT = 'visit',
  VISIT_DETAIL = 'visitDetail',
  REVIEW_TAB = 'reviewTab',
  REVIEW_TAB_OTHERS = 'reviewTabOthers',
}
